import { fetchOrchidAPI } from "utils/api";
import { getErrorDetail } from "components/utility/utils.js";

type Params = {
  search?: string;
  skip?: number;
  /**
   * @default 100
   */
  limit?: number;
  patientType?: string;
  clientStatus?: string[];
  onBehalfOf?: string;
};

export default async function listPatientChart(
  {
    search,
    skip = 0,
    limit = 100,
    patientType = "individual",
    clientStatus,
    onBehalfOf,
  }: Params,
  signal?: AbortController["signal"],
): Promise<{
  limit: number;
  entries: PatientChartResponseEntry[];
  skip: number;
  total_count: number;
  stats: PatientChartResponseStats;
}> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/patient_chart/?${new URLSearchParams({
      ...(search && { search }),
      skip: skip.toString(),
      limit: limit.toString(),
      patient_type: patientType,
      ...(onBehalfOf && { on_behalf_of: onBehalfOf }),
    }).toString()}${
      clientStatus?.length && clientStatus.length > 0
        ? `&${new URLSearchParams(
            clientStatus?.map((s) => ["client_status", s]),
          ).toString()}`
        : ""
    }`,
    signal && {
      signal,
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}

export const listPatientChartNormalized = async (params: Params) => {
  const result = await listPatientChart(params);
  return result.entries;
};
